import React from 'react'
import { Stack, Switch, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function LabelledSwitch({ trueLabel, falseLabel, ...others }) {
  const { t } = useTranslation()

  return (
    <>
      <Stack
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        px={2}
      >
        <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>
          {falseLabel || t('common.form.switch.false')}
        </Typography>
        <Switch {...others} />
        <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>
          {trueLabel || t('common.form.switch.true')}
        </Typography>
      </Stack>
    </>
  )
}
